<template>
  <div class="wrapper">
	   <headerTag />
       <div class="detailCon1">
		  <img src="../../assets/images/detail/dlysxkz.png" alt=""  />
	   </div>
	   <div class="detailCon1-div1 clear">
	   			  <p>
	   				  <span>道路运输许可证</span>
	   				  <span v-if="productPrice=='my'">
	   				  		面议
	   				  </span>
	   				  <span v-else>
	   				  		￥{{productPrice}}
	   				  </span>
	   			  </p>
	   			  <p>        
	   				多年行业经验，全包快速出证。
	   			  </p>
	    </div>
	 
	  <div class="detailCon detailCon3">
	  	  <p class="detailCon2-tips" style="margin-top: 0;">
	  		 服务简介
	  	   </p>
		   
		   <p>
				道路运输许可证，是单位、团体、和个人有权利从事道路运输经营活动的证明。
				<br>既从事物流和货运站场企业经营时必须取得的前置许可，物流公司根据经营范围的不同视当地政策情况办理道路运输经营许可证，有此证的公司方可有营运的车辆，是车辆上营运证的必要条件。
				                       
			</p>
	   </div>
	  <div class="detailCon detailCon4">
	   	  <p class="detailCon2-tips" style="margin-top: 0;">
	   		 服务流程
	   	   </p>
	   	   <p>
			   <span>
				   <img src="../../assets/images/detail/liucheng1.png" alt="" />
				   <i>咨询下单</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng2.png" alt="" />
			   		<i>提交材料</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng3.png" alt="" />
			   		<i>业务办理</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng4.png" alt="" />
			   		<i>售后服务</i>
			   </span>
		   </p>
	    </div>
	  <div class="detailCon detailCon5">
			  <p class="detailCon2-tips" style="margin-top: 0;">
				 所需材料
			   </p>
			  <div>
				  <p><i></i><span>申请报告、企业名称预先核准通知书</span></p>
				  <p><i></i><span>法人任职文件、身份证明文件</span></p>
				  <p><i></i><span>经营管理、技术、财务人员名册及相应的职称证明</span></p>
				  <p><i></i><span>车辆行驶复印件、驾驶人员驾驶证、从业资格证、搬运装卸人员操作证</span></p>
				  <p><i></i><span>办公场所、经营场地证明、消防合格证明</span></p>
				  <p><i></i><span>企业经营管理、车辆技术管理及运输安全管理制度</span></p>
			  </div>
	  </div>
		
		<div class="detailBottom-box">
			<div class="detailBottom">
				<p @click="runQq()">
					<i>
						<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.23rem;" />
					</i>
					
					<span>QQ联系</span>
				</p>
				<p @click="runWx()">
					<i>
						<img src="../../assets/images/detail/weixin.png" alt="" style="height: 1rem;" />
					</i>
					<span>微信联系</span>
				</p>
				<p>
					<a :href="'tel:'+phoneNum">
						<i>
							<img src="../../assets/images/detail/phone.png" alt="" style="height: 0.92rem;" />
						</i>
						<span>电话联系</span>
					</a>
				</p>
				<button @click="buyThis" v-bind:disable="dis" :class="{'cur': dis == true}">{{buyBtn}}</button>
			</div>
		</div>
		
		
		<van-popup v-model="wxShow" class="popDiv erDiv">
				<p>
					<span>扫码咨询</span>
					<img src="../../assets/images/detail/close.png" class="closeImg" @click="wxShow=false" />
				</p>
				<img :src="wxPic" class="erImg" />
				<p class="wxTitle">
					<i></i>
					<span>微信号</span>
					<i></i>
				</p>
				<p class="erNum" id="copyValue">{{wxNum}}</p>
				<p class="copyBtn">
					<button @click="copy" data-agl-cvt="32" id="copyTxt" data-clipboard-action="copy" data-clipboard-target="#copyValue">复制</button>
				</p>
				<p class="wxTips">扫一扫或复制微信号，添加好友咨询~</p>
		</van-popup>
   </div>
</template>

<script>
  import "../../assets/css/detail.scss"
  import headerTag from '@/components/headerTag/headerTag.vue'
  import { getProductDetail,getProv,getCity,getCustomerInfo,openConsult,nowBuyProduct } from '../../assets/js/common.js' 
  import { myMixin } from '../../mixins' 
  import { Popup,Picker } from 'vant'
  import Clipboard from 'clipboard'
 
  export default {
    name: 'productDlysxkz',
	mixins:[myMixin],
	props:{
		
	},
	data(){
		return {
			bussFlag:27,
			isShow:0,
			wxShow:false,//微信弹框
			dis:true, //立即购买按钮的disable
			buyBtn:'请咨询客服',
		}
	},
	components: {
       headerTag,
	   [Popup.name]:Popup,
	   [Picker.name]:Picker ,
     },
	 methods:{
		 buyThis(){
		 	let _this=this;
		 	if(this.pid == null || this.pid == "" ){
			  	_this.$message.error({message: "暂无产品，请咨询客服"});
			  	return;
		    }
		    _this.dis=true; // 不可点击
			nowBuyProduct(this.pid,function(data){
				_this.dis=false;
				if(data.code == 1000){
					//成功
					window.location.href='/order/paySure/'+data.obj;
				}else if(data.code == 1110){
					//未登录
					let currPath=window.location.href;
					window.location.href='/login?targetUrl='+currPath;
				}else{
					_this.$message.error({message: errorback});
				}
			},(errorback)=>{
				_this.dis=false;
				_this.$message.error({message: errorback});
			})
		 }, 
		runQq(){//QQ联系
			openConsult(this.qqNum);
		},
		runWx(){//微信联系
			
			if(this.wxNum==null){
				this.wxShow=false;
				this.$message('该业务员暂无微信');
			}else{
				this.wxShow=true;
			}
		},
		copy(){
			var clipboard = new Clipboard('#copyTxt', {
			    text: function () {
			        //return $('#copyValue').text();
			    }
			});
					
			clipboard.on('success', e => {  
				this.$message.success({message: '已复制成功，快去微信添加好友吧~~',customClass:'mzindex'});
				// 释放内存  
				clipboard.destroy()  
			})  
			clipboard.on('error', e => {  
				  // 不支持复制 
				   this.$message.error({message: '抱歉哦，复制失败请手动复制微信号~~',customClass:'mzindex'});
				  // 释放内存  
				  clipboard.destroy()  
			})  
			       
		},
	 },
	 created() {
		 let _this = this;
		getProductDetail(27,this.$route.params.pid,function(data){ //产品信息
			if(data.obj == "" || data.obj == null){
				_this.productPrice='my';
				_this.dis=true;
				_this.buyBtn="请咨询客服";
			}else{
				_this.productPrice=data.obj.price;
				_this.pid = data.obj.pid;
			}
		},(errorback)=>{
			_this.$message.error({message: errorback});
		})
		
		getCustomerInfo(function(data){//业务员信息
			_this.qqNum=data.qq;
			_this.wxNum=data.wx;
			_this.phoneNum=data.phone;
			_this.wxPic=_this.rootUrl+data.wxPic;
		},()=>{
			_this.$message.error({message: '网络异常，请稍后重试'});
		})
		
	 },
   }
</script>